import "./Inventory.css";

import { getInventoryUnitLabel } from "../../../../utils";
import { Column, CursorDataGrid, InventoryChartKey, Row, StackedBarChart } from "../../../../widget";
import { useInventory } from "./useInventory";

const Inventory = (): JSX.Element => {
  const {
    onChange,
    columns,
    isLoading,
    hasProjectDetails,
    hasData,
    hasEnoughIssuancesForScrolling,
    unitMeasurement,
    xAxisLabels,
    stackedChartData,
    showAvailable,
    chartKeyNutrients,
    defaultSortingCriteria,
  } = useInventory();

  /*
    D-4 - Nutrient Neutrality quantities are an annual rate, so the axis and the tooltip carry the
    unit; without it a bar reading 50 is an ambiguous count. Undefined for every other measurement,
    which leaves their chart options untouched: the tooltip then falls back to StackedBarChart's own
    `label: value` callback. Mirrors the pre-access chart, which draws the same data.
  */
  const unitLabel = getInventoryUnitLabel(unitMeasurement);

  return (
    <div className="PublicProjectTabSection">
      <Row spacingV="ll">
        <Column span={12}>
          <h2>Inventory</h2>
        </Column>
      </Row>
      {stackedChartData && xAxisLabels && hasProjectDetails && hasData && (
        <Row spacingV="2xl">
          <Column span={12}>
            <StackedBarChart
              xLabels={xAxisLabels}
              data={stackedChartData}
              hasYAxisGridLines
              hasYAxisTicks
              showLegend={false}
              yAxisTitle={unitLabel}
              customTooltipLabel={
                unitLabel ? (context) => `${context.dataset.label}: ${context.parsed.y}${unitLabel}` : undefined
              }
            />
            <InventoryChartKey
              surface="public"
              unitMeasurement={unitMeasurement}
              showAvailable={showAvailable}
              nutrients={chartKeyNutrients}
            />
          </Column>
        </Row>
      )}
      {hasProjectDetails && (
        <Row spacingV={hasEnoughIssuancesForScrolling ? "ml" : undefined}>
          <Column span={12}>
            <div className={`ProjectInventoryDataGrid ${hasEnoughIssuancesForScrolling ? "Scrollable" : ""}`}>
              <CursorDataGrid
                columns={columns}
                clientSide={false}
                onChange={onChange}
                data={[]}
                defaultSortingCriteria={defaultSortingCriteria}
                pagination={{ pageSize: 1000 }}
                dataIsLoading={isLoading}
                noDataMessage="No inventory to display"
                hasTotalRow
                totalColumnNames={["unitQuantityAvailable", "unitQuantityTotal"]}
                infiniteScroll
              />
            </div>
          </Column>
        </Row>
      )}
    </div>
  );
};

export default Inventory;
